import useQueries from '../../../database/useQueries';
import { useIndexedDBSync } from '../../../database/dataLocal/indexedDBHooks';
import { formatPriceIL } from './data/commponentOptions';

const useCalculatePrice = () => {
  const { getEntityByAttr } = useQueries();

  const localCemeteries = useIndexedDBSync('myStore', 'dataCemeteries');
  const localBlocks = useIndexedDBSync('myStore', 'dataBlocks');
  const localPlots = useIndexedDBSync('myStore', 'dataPlots');
  const localAreaGraves = useIndexedDBSync('myStore', 'dataAreaGraves');
  const localGraves = useIndexedDBSync('myStore', 'dataGraves');
  const localRows = useIndexedDBSync('myStore', 'dataRows');
  const localPayments = useIndexedDBSync('myStore', 'dataPayments');
  const localCustomers = useIndexedDBSync('myStore', 'dataCustomers');

  const calculatePrice = (values) => {
    console.log('step 1', values);

    let tempType = [];
    const { clientId, buyerStatus, cemeteryId, blockId, plotId, lineId, graveId } = values;

    let customer = getEntityByAttr(localCustomers, 'unicId', clientId);
    let grave = getEntityByAttr(localGraves, 'unicId', graveId);
    let areaGrave = getEntityByAttr(localAreaGraves, 'plotId', plotId);
    let line = getEntityByAttr(localRows, 'unicId', lineId);
    let plot = getEntityByAttr(localPlots, 'unicId', plotId);
    let block = getEntityByAttr(localBlocks, 'unicId', blockId);
    let cemetery = getEntityByAttr(localCemeteries, 'unicId', cemeteryId);

    // פונקציה לאיפוס זמן של תאריך (שעות, דקות, שניות ומילישניות)
    const resetTime = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const today = resetTime(new Date());

    console.log('step 2: ', today);
    // יוצר עותק של המערך, ממיין אותו לפי תאריך, ומסנן תאריכים אחרי היום הנוכחי
    const sortedPayments = localPayments
      .slice()
      .filter((pay) => resetTime(new Date(pay.startPayment)) <= today)
      .sort((a, b) => new Date(a.startPayment) - new Date(b.startPayment));

    // const today = new Date();

    console.log('step 3: ', sortedPayments);
    // // יוצר עותק של המערך, ממיין אותו לפי תאריך, ומסנן תאריכים אחרי היום הנוכחי
    // const sortedPayments = localPayments.slice()
    //   .filter(pay => new Date(pay.startPayment) <= today)
    //   .sort((a, b) => new Date(a.startPayment) - new Date(b.startPayment));

    console.log(sortedPayments);
    // עובר על המערך הממויין ומדפיס לקונסול
    sortedPayments.forEach((pay) => {
      // בדיקת מיקום
      if (pay?.cemeteryId === '-1' || pay?.cemeteryId === -1 || pay?.cemeteryId === cemetery?.unicId) {
        // console.log('step cemetery: ', pay?.cemeteryId);
        if (pay?.blockId === '-1' || pay?.blockId === -1 || pay?.blockId === block?.unicId) {
          // console.log('step block: ', pay?.blockId);
          if (pay?.plotId === '-1' || pay?.plotId === -1 || pay?.plotId === plot?.unicId) {
            // console.log('step plot: ', pay?.plotId)
            if (pay?.lineId === '-1' || pay?.lineId === -1 || pay?.lineId === line?.unicId) {
              // console.log('step row: ', pay?.lineId, pay?.price)
              // בדיקת סוג הקבר
              if (pay?.graveType === '-1' || pay?.graveType === -1 || pay?.graveType === areaGrave?.graveType) {
                // console.log('step graveType: ',pay?.graveType, pay?.price)
                // בדיקת סוג החלקה
                if (pay?.plotType === '-1' || pay?.plotType === -1 || pay?.plotType === grave?.plotType) {
                  // console.log('step plotType: ', pay?.plotType, pay?.price);
                  // בדיקת כתובת
                  // console.log(pay?.resident, customer?.resident);

                  if (pay?.resident === '-1' || pay?.resident === -1 || pay?.resident === customer?.resident) {
                    console.log('step resident:', pay?.resident, pay?.price);
                    // בדיקת סטטוס רוכש
                    if (pay?.buyerStatus === '-1' || pay?.buyerStatus === -1 || pay?.buyerStatus === buyerStatus) {
                      // console.log('step buyerStatus: ',pay?.buyerStatus)
                      // בדיקת סוג תשלום
                      const index = tempType.findIndex((item) => item.name === pay?.priceDefinition);
                      if (index === '-1' || index === -1) {
                        tempType.push({ name: pay?.priceDefinition, value: pay?.price });
                      } else {
                        tempType[index] = { name: pay?.priceDefinition, value: pay?.price };
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

    return tempType;
  };

  return calculatePrice;
};

export default useCalculatePrice;
